export interface UtilityNavProps {
  className?: string;
}

export function UtilityNav({ className = "" }: UtilityNavProps) {
  const utilityItems = [
    {
      text: "Contact",
      href: "/contact"
    },
    {
      text: "Scheduling", 
      href: "https://prod.myfbo.com/link.asp?fbo=nora"
    },
    {
      text: "Safety Reporting Form",
      href: "https://docs.google.com/forms/d/1HRYhhq1j11cr3LmmUeYFXmmpKGDlBrOMCjXofZfS4Kw/edit?ts=602ae6b3"
    }
  ];

  return (
    <nav className={className}>
      <ul className="flex items-center gap-6">
        {utilityItems.map((item) => (
          <li key={item.text}>
            <a
              href={item.href}
              className="text-sm text-gray-600 hover:text-blue-600 transition-colors duration-200"
              {...(item.href.startsWith('http') && {
                target: "_blank",
                rel: "noopener noreferrer"
              })}
            >
              <span>{item.text}</span>
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}